import { render, staticRenderFns } from "./EniNumeri.vue?vue&type=template&id=15ffd5ce&scoped=true&"
import script from "./EniNumeri.vue?vue&type=script&lang=js&"
export * from "./EniNumeri.vue?vue&type=script&lang=js&"
import style0 from "./EniNumeri.vue?vue&type=style&index=0&id=15ffd5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ffd5ce",
  null
  
)

component.options.__file = "EniNumeri.vue"
export default component.exports